import React, { useEffect, useState } from "react";
import logo from "../Images/logo.webp";
import './TopHeader.css';
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { RiMoonLine, RiSunLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const TopHeader = ({setClassName,darkMode, onDistrictChange })=> {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState(() => {
      const storedDistrict = localStorage.getItem("selectedDistrict") || "Lucknow";
  
      // Set the state based on the district or default to "Uttar Pradesh" if district is Lucknow
      const storedState = localStorage.getItem("selectedDistrictState") || (storedDistrict === "Lucknow" ? "Uttar Pradesh" : "");
        return {
          district: storedDistrict,
          state: storedState,
        };
      });
      const [showConfirm, setShowConfirm] = useState(false); // To show the modal
      const [tempDistrict, setTempDistrict] = useState(selectedDistrict);  

    useEffect(() => {
      // Notify parent about the initially selected district and state
      if (onDistrictChange) {
        onDistrictChange(selectedDistrict);
      }
    }, []); // Run only on mount

  const darkModeIcon = () => {
    setIsDarkMode(!isDarkMode);
  };
  const handleDarkModeClick = () => {
    darkMode();
    darkModeIcon();
  };


  const districtStateMap = {
    // Ajmer: "Rajasthan",
    // Balrampur: "Uttar Pradesh",
    // Bareilly: "Uttar Pradesh",
    Delhi: "",
    // Ghazipur : "Uttar Pradesh",    
    Indore: "Madhya Pradesh",
    Jabalpur: "Madhya Pradesh",
    // Kanpur: "Uttar Pradesh",
    Lucknow: "Uttar Pradesh",
    // Mumbai: "Maharashtra",
    // Noida: "Uttar Pradesh",
    // Pilibhit: "Uttar Pradesh",
    // Sitamarhi: "Bihar",

  };

  const districtOptions = Object.keys(districtStateMap);

  // const handleChange = (e) => {
  //   const newDistrict = e.target.value;
  //   const newState = districtStateMap[newDistrict] || "";
  
  //   setTempDistrict({ district: newDistrict, state: newState });
  //   setShowConfirm(true);
  // };

  const handleChange = (event, newValue) => {
    if (newValue) {
      const newState = districtStateMap[newValue] || "";
      setTempDistrict({ district: newValue, state: newState });
      setShowConfirm(true);
    }
  };

  const handleConfirm = (isPermanent) => {
    if (isPermanent) {
      // Save the district permanently in localStorage
      localStorage.setItem("selectedDistrict", tempDistrict.district);
      localStorage.setItem("selectedDistrictState", tempDistrict.state);
    }
    // Always update the state to reflect the change
    setSelectedDistrict(tempDistrict);

    // Notify parent component about the district change
    if (onDistrictChange) {
      onDistrictChange(tempDistrict);
    }

    setShowConfirm(false); // Close the modal
  };

  useEffect(() => {
    if (onDistrictChange) {
      onDistrictChange(selectedDistrict);
    }
  }, []); // Run only on mount
  
  useEffect(() => {
  if (showConfirm) {
    // Close the mobile keyboard by blurring the active element
    if (document.activeElement) {
      document.activeElement.blur();
    }
  }
}, [showConfirm]);

    return (
       <>
        <header className="header-section">
        <a href="#main" className="skip">Skip to main content</a>
            <Link to='/'>
            <div className="header-section__item">
                <img src={logo} className="logo"  alt="logo" title="logo" width={110} height={79} />
            </div>
            </Link>
            <div className="header-section__item2">
                <div className="header-section__hadees">
                        <p className='urduFont urduHadees'>طَلَبُ الْعِلْمِ فَرِيضَةٌ عَلَى كُلِّ مُسْلِمٍ</p> 
                 </div>
                  {/* MUI Select */}
                  <Autocomplete
                    disablePortal
                    options={districtOptions}
                    value={selectedDistrict.district}
                    onChange={handleChange}
                    getOptionDisabled={(option) => option === selectedDistrict.district}
                    sx={{ m: 1, minWidth:152 }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Location" />}
                    className="changeDist"
                      slotProps={{
                        listbox: {
                          id: 'my-custom-listbox'
                        }
                      }}
                      onOpen={() => {
                        setTimeout(() => {
                          const listbox = document.querySelector('#my-custom-listbox');
                          if (listbox) {
                            listbox.scrollTop = 0;
                          }
                        }, 0);
                      }}
                  />
                {showConfirm && (
                        <div className="custom-modal">
                          <div className="modal-content">
                             <div className="text-center"><span className="icon-info"><IoIosInformationCircleOutline size={20}/></span></div>
                             <p className="text-center my-10 fs-20">Confirm</p>
                              <p className="msg">Do you want to set <b>{tempDistrict.district}</b> as your default location?</p>
                             <div className="btn-groups">
                              <button onClick={() => handleConfirm(true)} className="btn btn-confirm">Yes</button>
                              <button onClick={() => handleConfirm(false)} className="btn btn-cancel">No</button>
                             </div>
                          </div>
                        </div>
                    )}
                
               <div className="d-flex iconsContainer">
               <span className="moonIcon" onClick={handleDarkModeClick}>
                 {isDarkMode ? <RiSunLine /> : <RiMoonLine />}
                </span>
                <span className="hamburgerIcon" onClick={setClassName}><GiHamburgerMenu /></span>
                <input type="text" placeholder="Serch here" className="searchInput"/>
               </div>
            </div>
        </header>
       </>
    )
}

export default TopHeader;
